import { uploadImage } from 'services/cloudinary-service';

export const uploadImages = async files => {
  const filesUrl = await Promise.all(Object.keys(files).map(async key => await uploadImage(files[key])));
  return filesUrl;
};
